export default {
  props: ['coursework'],
  template: '#forum_participation_step_template',
  data() {
    return {
      number: 0,
      name: 'Forum Participation',
      task: 'Participate in forums',
      isInView: false
    };
  },
  computed: {
    isVisible() {
      return this.coursework.has_forum_participation_grading;
    },
    isActive() {
      return this.isVisible;
    },
    isComplete() {
      return !this.coursework.is_forum_participation_pending;
    }
  },
  created() {
    this.$parent.steps.push(this);
  }
};
